var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.0003L10.7506 2.99979C11.481 2.41544 12.519 2.41544 13.2494 2.99979L22 10.0003",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47763 4.04964L5.47763 7.29964C4.75138 7.88972 4.38825 8.18476 4.19412 8.59261C4 9.00046 4 9.46834 4 10.4041V14.0002C4 17.7714 4 19.6571 5.17157 20.8286C6.34315 22.0002 8.22876 22.0002 12 22.0002C15.7712 22.0002 17.6569 22.0002 18.8284 20.8286C20 19.6571 20 17.7714 20 14.0002V10.4041C20 9.46834 20 9.00046 19.8059 8.59261C19.6117 8.18476 19.2486 7.88972 18.5224 7.29964L14.5224 4.04964C13.3142 3.06798 12.7101 2.57715 12 2.57715C11.2899 2.57715 10.6858 3.06798 9.47763 4.04964Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 16.25H14.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHome);
export default __webpack_public_path__ + "static/media/menu_home.8020727f103bf428ae2b531496159b67.svg";
export { ForwardRef as ReactComponent };